// extracted by mini-css-extract-plugin
export default {"userName":"UserMenu_userName__FSHsW"};